import { render } from "./PollCard.vue?vue&type=template&id=52377b9a"
import script from "./PollCard.vue?vue&type=script&lang=js"
export * from "./PollCard.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__